export default __webpack_public_path__ + "static/media/i24.967f43da.svg";